import React from 'react'
import { Card } from 'react-bootstrap'

const CharacterModalPlayer = (props) => {
  return (
    <>
      <Card className='no-border'>
        <Card.Img className='character-player-viewer' src={"/assets/character/thumbnail/enlarge/" + props.name} alt={props.name}/>
      </Card>
    </>
  )
}

export default CharacterModalPlayer
